
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Default_logo from "../assets/images/default_logo.png";

const ProviderDetails = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);

    useEffect(() => {
        // Retrieve the user object from localStorage
        const userJson = localStorage.getItem('selectedUser');
        if (userJson) {
            setUser(JSON.parse(userJson));
        }
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleContactClick = () => {
        navigate('/ContactSalesForm', {
            state: { providerDetails: user._id }, // Pass the provider email
        });
    };

    if (!user) {
        return <div className="no-user">No user details found</div>;
    }

    return (
        <>
            <style jsx="true">{`
                /* Mobile-specific styles for ProviderDetails */
                @media (max-width: 767.98px) {
                    .provider-details-container-mobile {
                        padding: 15px !important;
                        margin-bottom: 80px !important; /* Space for the fixed button */
                    }
                    
                    .contact-sales-button-mobile {
                        position: fixed !important;
                        bottom: 0 !important;
                        left: 0 !important;
                        right: 0 !important;
                        background: white !important;
                        padding: 15px !important;
                        box-shadow: 0 -2px 10px rgba(0,0,0,0.1) !important;
                        z-index: 1000 !important;
                    }
                    
                    .contact-sales-button-mobile .btn {
                        width: 100% !important;
                        min-height: 48px !important;
                        font-size: 16px !important;
                        margin: 0 !important;
                    }
                    
                    .detail-item-mobile {
                        margin-bottom: 15px !important;
                        word-break: break-word !important;
                    }
                    
                    .detail-item-mobile a {
                        word-break: break-all !important;
                        overflow-wrap: anywhere !important;
                    }
                    
                    .user-details-mobile {
                        padding-bottom: 100px !important; /* Space for fixed button */
                    }
                }
                
                /* Desktop styles remain unchanged */
                @media (min-width: 768px) {
                    .contact-sales-button-mobile {
                        position: relative !important;
                        padding: 20px 0 !important;
                    }
                    
                    .contact-sales-button-mobile .btn {
                        width: auto !important;
                    }
                }
            `}</style>
            
            <div className="provider-details-container provider-details-container-mobile">
                <h1 className="header">Provider Details</h1>

                {/* Company logo at the top */}
                {user.company_logo ? (
                    <div className="logo-container mb-4">
                        <img
                            src={`data:image/png;base64,${user.company_logo}`}
                            alt="Company Logo"
                            className="company-logo"
                            style={{ maxWidth: "200px", maxHeight: "100px", objectFit: "contain" }}
                        />
                    </div>
                ) : (
                    <div className="mb-4">
                        <img
                            src={Default_logo}
                            alt="Default logo"
                            style={{ width: "100px", height: "100px", objectFit: "contain" }}
                        />
                    </div>
                )}

                <div className="user-details user-details-mobile" style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    width: '100%',
                    padding: '20px'
                }}>
                    {user.company && (
                        <div className="detail-item detail-item-mobile mb-3">
                            <strong>Company:</strong> {user.company}
                        </div>
                    )}
                    
                    {user.GeoWGS84_partner_no && (
                        <div className="detail-item detail-item-mobile mb-3">
                            <strong>GeoWGS84 Partner No:</strong> {user.GeoWGS84_partner_no}
                        </div>
                    )}
                    
                    {user.city && (
                        <div className="detail-item detail-item-mobile mb-3">
                            <strong>City:</strong> {user.city}
                        </div>
                    )}
                    
                    {user.state && (
                        <div className="detail-item detail-item-mobile mb-3">
                            <strong>State:</strong> {user.state}
                        </div>
                    )}
                    
                    {user.ZIPCode && (
                        <div className="detail-item detail-item-mobile mb-3">
                            <strong>ZIP Code:</strong> {user.ZIPCode}
                        </div>
                    )}
                    
                    {user.country && (
                        <div className="detail-item detail-item-mobile mb-3">
                            <strong>Country:</strong> {user.country}
                        </div>
                    )}
                    
                    {user.drones_do_you_have && user.drones_do_you_have.length > 0 && (
                        <div className="detail-item detail-item-mobile mb-3">
                            <strong>Drones:</strong>
                            <ul className="mt-2 mb-0">
                                {user.drones_do_you_have.map((drones_do_you_have, index) => (
                                    <li key={index}>{drones_do_you_have}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                    
                    {user.services && user.services.length > 0 && (
                        <div className="detail-item detail-item-mobile mb-3">
                            <strong>Services:</strong>
                            <ul className="mt-2 mb-0">
                                {user.services.map((service, index) => (
                                    <li key={index}>{service}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                    
                    {user.geometryfile && (
                        <div className="detail-item detail-item-mobile mb-3">
                            <strong>Service Area KML File:</strong>
                            <div className="mt-2">
                                <a 
                                    href={user.geometryfile} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="text-break"
                                >
                                    {user.geometryfile}
                                </a>
                            </div>
                        </div>
                    )}
                </div>
                
                <div className="contact-sales-button contact-sales-button-mobile">
                    <button 
                        onClick={handleContactClick} 
                        className="btn btn-primary px-4 py-2"
                    >
                        Contact Our Sales Team
                    </button>
                </div>
            </div>
        </>
    );
};

export { ProviderDetails };